import { create } from 'zustand';
import type { LoginResponse } from '../api/auth';

interface AuthState {
  user: LoginResponse['user'] | null;
  setUser: (u: LoginResponse['user'] | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));
